module.exports = __webpack_public_path__ + "static/img/3_1.0a6b2192.png";